import React, { memo } from 'react';
import NotificationIcon from '.';

// This wrapper component prevents re-renders from propagating
const NotificationIconContainer = memo(() => {
  return <NotificationIcon />;
});

export default NotificationIconContainer;
